import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Handshake, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import marketerApi, { MARKETER_TOKEN_KEY } from '../../lib/marketerApi';
import BrandLogo from '../../components/brand/BrandLogo';

export default function MarketerLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await marketerApi.post('/affiliate/public/login', { email, password });
      localStorage.setItem(MARKETER_TOKEN_KEY, data.token);
      toast.success('Welcome back!');
      nav('/affiliate/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen mesh-bg flex items-center justify-center p-4" data-testid="marketer-login">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center justify-center mb-5"><BrandLogo height={36} /></Link>
        <div className="fab-card p-6 sm:p-8">
          <div className="flex items-center gap-2 mb-1">
            <Handshake className="w-5 h-5 text-fab-primary" />
            <h1 className="font-display text-xl font-bold text-fab-text">Marketer Portal</h1>
          </div>
          <p className="text-[13px] text-fab-text-secondary mb-5">Sign in to track your referrals and earnings.</p>
          <form onSubmit={submit} className="space-y-3">
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" type="email" data-testid="marketer-login-email" className="fab-input w-full px-3.5 py-2.5 rounded-lg border border-fab-primary-lighter text-[14px]" />
            <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" type="password" data-testid="marketer-login-password" className="fab-input w-full px-3.5 py-2.5 rounded-lg border border-fab-primary-lighter text-[14px]" />
            <button type="submit" disabled={loading} data-testid="marketer-login-submit" className="btn-primary w-full py-2.5 text-[14px] flex items-center justify-center gap-2">
              {loading ? 'Signing in…' : <>Sign In <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
          <div className="text-[13px] text-fab-text-secondary mt-4 text-center">
            New community marketer? <Link to="/affiliate/register" className="text-fab-primary font-semibold">Join free</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
